var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page',{attrs:{"card-content":"","flex-column":""}},[_c('hazard-common-edit',{attrs:{"title":"隐患问题上报","type":"new"},on:{"success":_vm.whenEditSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }